export interface LoaderButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  children: React.ReactNode;
}

export const LoaderButton: React.FC<LoaderButtonProps> = ({ loading = false, disabled, children, ...props }) => {
  return (
    <button disabled={disabled || loading} {...props}>
      {loading && <span className="loading loading-spinner loading-sm mr-2" />}
      {children}
    </button>
  );
};
